import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const ApiCaller = async (endpoint, method = "POST", body = {}) => {
  try {
    let response;

    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    };

    if (method.toUpperCase() === "GET") {
      response = await axios.get(`${BASE_URL}${endpoint}`, { headers });
    } else {
      response = await axios.post(`${BASE_URL}${endpoint}`, body, { headers });
    }

    return response.data;
  } catch (error) {
    console.error('API call error:', error);
    throw error;
  }
};